<template>
  <PageWrap page-title="Estado de los inmuebles">
    <LoadingIndicator v-if="loadingData" />

    <BfTable
      v-else
      :data="estados"
      :columns="tableColumns"
      border
      @row-click="tableRowClick
            cell-class-name="tasaciones-small-cell"
"
    >
      <span slot="nombre" slot-scope="{row}" class="tasaciones-table-marker">
        {{row.nombre}}
      </span>
    </BfTable>

    <BfButton
      :to="{name: 'estadoinmueble'}"
      tag="router-link"
      class="mt-5"
    >
      Nuevo Estado para Inmueble
    </BfButton>
  </PageWrap>
</template>

<script>
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { propertyStatusTypeAPI } from '@/api';

export default {
  name: 'PropertyStatusesList',

  data() {
    return {
      loadingData: false,
      estados: [],
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loadingData = true;

      try {
        const {
          data: { data = [] },
        } = await propertyStatusTypeAPI.getAll();

        this.estados = data;
      } finally {
        this.loadingData = false;
      }
    },

    tableRowClick({ row, column }) {
      if (column.property === 'nombre') {
        const { id } = row;
        router.push({ name: 'estadoinmueble', params: { id: `${id}` } });
      }
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          label: 'Nombre',
          dataKey: 'nombre',
          sortable: true,
        },
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
